import { Record } from "@common/data-models/records/record";
import { ViewStateRecord } from "@common/data-models/records/viewstate-record";
import { GlobalTablesService } from "@common/services/global-tables-service";

export class RecordFactory {
    private static recordConstructors: { [id: number]: new () => Record } = {};
    private static templateRecordConstructors: { [id: number]: new () => Record } = {};
    private static viewStateRecordConstructors: { [id: number]: new () => ViewStateRecord } = {};

    public static registerRecord(objectType: number, constr: new () => Record) {
        RecordFactory.recordConstructors[objectType] = constr;
    }

    public static registerTemplateRecord(objectType: number, constr: new () => Record) {
        RecordFactory.templateRecordConstructors[objectType] = constr;
    }

    public static registerViewStateRecord(viewStateType: number, constr: new () => ViewStateRecord) {
        RecordFactory.viewStateRecordConstructors[viewStateType] = constr;
    }

    public static createTemplateForType<T extends Record>(objectType: number): T {
        if (RecordFactory.templateRecordConstructors[objectType]) {
            return <T>(new RecordFactory.templateRecordConstructors[objectType]());
        } else {
            throw "Unable to create record template for type " + objectType;
        }
    }

    public static createRecordForType<T extends Record>(objectType: number): T {
        if (RecordFactory.recordConstructors[objectType]) {
            return <T>(new RecordFactory.recordConstructors[objectType]());
        } else {
            throw "Unable to create record for type " + objectType;
        }
    }

    public static createViewStateForType<T extends ViewStateRecord>(viewStateType: number): T {       
        if (RecordFactory.viewStateRecordConstructors[viewStateType]) {
            return <T>(new RecordFactory.viewStateRecordConstructors[viewStateType]());
        } else {
            throw "Unable to create record for view state type " + viewStateType;
        }
    }
}
